<template>
  <div>
    <div style="height: 15px">
      <span :class="`service ${props.statusCor}`">
        {{ props.setor }}
      </span>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  statusCor: String,
  setor: String
})
</script>
<style>
.danger {
  background-color: #ee3124;
}

.darkyellow {
  background-color: #bd820f;
}

.warning {
  background-color: #ffb822;
}

.info {
  background-color: #2b70e8;
}

.service{
    color: #fff;    
    border-radius: 2px;
    padding: 2px 9px;
    text-transform: uppercase;
    -webkit-box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
}

</style>
